import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import {
  BfxConfigService,
  BfxSysConfigUtilService,
  SystemConfigPromiseService,
} from "shared/auth-services";
import {
  AlgoStrategyLookupService,
  CcyPairLookupService,
  CcyLookupService,
  ClientLookupService,
  CurrencyPairCalendarLookupService,
  ProfilePromiseActionService,
  ProfileSettingKeys,
  SalesGroupLookupService,
  TableDefinition,
  UserLookupService,
} from "shared/cubiq-services";
import { FwdRollBaseTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollBaseTableDefinitionFactory";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import {
  FWD_ROLL_CCYS_TABLE_DEFINITION_VER,
  FWD_ROLL_ORDERS_TABLE_DEFINITION_VER,
} from "shared/cubiq-services/model/TableDefinitionFactory.constants";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FwdRollCurrencyTableDefinitionFactory extends FwdRollBaseTableDefinitionFactory {
  constructor(
    profileService: ProfilePromiseActionService,
    ccyPairLookupService: CcyPairLookupService,
    ccyLookupService: CcyLookupService,
    sysConfigService: SystemConfigPromiseService,
    clientLookup: ClientLookupService,
    userLookupService: UserLookupService,
    salesGroupLookup: SalesGroupLookupService,
    currencyPairCalendarLookupService: CurrencyPairCalendarLookupService,
    algoStrategyLookupService: AlgoStrategyLookupService,
    sysConfigUtil: BfxSysConfigUtilService,
    configService: BfxConfigService,
  ) {
    super(
      profileService,
      ccyPairLookupService,
      ccyLookupService,
      sysConfigService,
      clientLookup,
      userLookupService,
      salesGroupLookup,
      currencyPairCalendarLookupService,
      algoStrategyLookupService,
      sysConfigUtil,
      configService,
    );
  }

  public override createDef(): TableDefinition {
    super.createDef();

    let td = new TableDefinition("rowId", "rowId");

    // requestSubmissionTime's column
    td.setDefaultSort(1, "desc");

    // ccy
    let ccyCol: BfxColDef = this.createNetCcyColumn();
    td.addColumn(ccyCol);

    // direction
    let intentCol: BfxColDef = this.createNetIntentColumn();
    td.addColumn(intentCol);

    // value date
    let valueDateCol: BfxColDef = this.createValueDateColumn();
    td.addColumn(valueDateCol);

    // Position Amount
    let orderAmtCol: BfxColDef = this.createNetFixedAmtColumn();
    td.addColumn(orderAmtCol);

    // usd entered amount
    const usdEquivCol: BfxColDef = this.createNetUSDEquivAmtColumn();
    td.addColumn(usdEquivCol);

    // market forward points
    let marketForwardPointsCol: BfxColDef = this.createMarketForwardPtsColumn();
    td.addColumn(marketForwardPointsCol);

    // market spot
    let marketSpotCol: BfxColDef = this.createMarketSpotColumn(true);
    td.addColumn(marketSpotCol);

    // market all-in rate
    let marketForwardRateCol: BfxColDef = this.createMarketForwardRateColumn(true);
    td.addColumn(marketForwardRateCol);

    // Prevent sorting for Currency table
    td.columns.forEach((col) => (col.sortable = false));
    return td;
  }

  public override getBlotterType(): CubiqTS.BlotterType {
    return null;
  }

  protected override getProfileSettingKey(): string {
    return `${ProfileSettingKeys.userProfileFwdRollBlotters}Currencies`;
  }

  public override getVersionIdentifier(): string {
    return FWD_ROLL_CCYS_TABLE_DEFINITION_VER;
  }
}
